import Header from '../components/header';
import '../css/index.scss';
import '../css/wblow.scss';

import { initCase } from '../js/wblow/case';
import { initSignup } from '../js/wblow/signup';
import { revealOnScroll } from '../js/adam/reveal';

new Header();

initCase();
initSignup();
revealOnScroll();
